// extracted by mini-css-extract-plugin
module.exports = {"emptyStateContainer":"src-common-empty-state-empty-state__emptyStateContainer--2x2-f"};